// extracted by mini-css-extract-plugin
module.exports = {"parentDiv":"styles_parentDiv__1wzE6"};